import { RestUrl } from "../common/cyan.types";

export class GovAddressUrl {
  public static paginateGovAddress: RestUrl = ["GET", "/address/paginate"];
}
